import axios from '../../axios-dashboard';

import * as actionTypes from './actionTypes';

export const newPasswordStart = () => {
    return {
        type: actionTypes.NEW_PASSWORD_START
    }
};

export const newPasswordSuccess = () => {
    return {
        type: actionTypes.NEW_PASSWORD_SUCCESS
    }
};

export const newPasswordFail = (error) => {
    return {
        type: actionTypes.NEW_PASSWORD_FAIL,
        error: error
    }
};

export const newPassword = (guid, password) => {
    return dispatch => {
        dispatch(newPasswordStart());
        const resetPassword = {
            guid: guid,
            password: password
        };
        const url = "/update-password";
        axios.post(url, resetPassword)
            .then(response => {
                dispatch(newPasswordSuccess())
            })
            .catch(err => {
                dispatch(newPasswordFail(err.response.data.error))
            })
    }
};